import React from 'react';
import { Typography, Box } from '@material-ui/core';
import useStyle from './LabelWithPars.style';
import CustomLabel from './components/CustomLabel';

interface IProps {
  label?: string;
  info?: string | number;
  className?: string;
}

const LabelWithPars: React.FC<IProps> = ({ label = '', info, className }) => {
  const style = useStyle();
  return (
    <Box display="flex" className={className}>
      <CustomLabel label={label} />
      <Box marginLeft={0.5}>
        <Typography variant="subtitle2" className={style.langLabel}>
          ({info})
        </Typography>
      </Box>
    </Box>
  );
};

export default LabelWithPars;
